import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const setPickerValues = createAsyncThunk('/DispatchBookings/getZoneDistances_Time',  (date) => {
    return {
      data : date
    }
  })
  export const setEligibleCheck = createAsyncThunk('/DispatchBookings/setEligibleCheck',  (check) => {
     
    return {
      data : check
    }
  })
  export const updateBookingExpense = createAsyncThunk('appDriverBookingExpense/getDeclinedBookExpenses', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DriverBookingExpense/Update', params, {mode:'cors'})
    return response
  })

  export const getAllMonthsInAYear = createAsyncThunk('Common/GetAllMonthList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetAllMonthList', params, {mode:'cors'})
    return response
  })

  export const getAllPreviouseYear = createAsyncThunk('Common/GetAllYearSummary', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetAllYearSummary', {mode:'cors'})
    return response
  })

  export const getDeclineExpenseData = createAsyncThunk('appDriverBookingExpense/getDeclinedBookExpenses', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DriverBookingExpense/GetDeclinedBookExpenses', params, {mode:'cors'})
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getEligibleDriversData = createAsyncThunk('appDrvrPayment/GetEligibleDrivers', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetEligibleDrivers', params, {mode:'cors'})
    return {
      params,
      data: response.data.data,
      allData: response.data.data,
      totalPages: response.data.total
    }
  })

  export const generatePayment = createAsyncThunk('appDrvrPayment/generatePayment', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GeneratePayment', params, {mode:'cors'})
    return response
  })

  export const getGeneratedPaymentsData = createAsyncThunk('appDrvrPayment/getGeneratedPayments', async (params) => {
       
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetGeneratedPayments', params, {mode:'cors'})
     
    return {
      params,
      data: response.data.data,
      allData: response.data.data,
      totalPages: response.data.total
    }
  })


  export const getAttentionPaymentsData = createAsyncThunk('appDrvrPayment/getAttentionPayments', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetAttentionPayments', params, {mode:'cors'})
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const setEditID = createAsyncThunk('appDrvrPaymentttt/setEditID', async (params) => {
    return {
      id : params.id
    }
  })

  export const getGeneratedPaymentsViewsData = createAsyncThunk('appDrvrPayment/getGeneratedPaymentsViews', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetGeneratedPaymentsViews', params, {mode:'cors'})
      
    return {
      params,
      getDrvrPaymentsMaster: response.data.getDrvrPaymentsMaster,
      getDriverPaymentMaster: response.data.getDriverPaymentMaster,
      getCollectFromDriverDetail: response.data.getCollectFromDriverDetail,
      getPayToDriverDetail: response.data.getPayToDriverDetail,
      getSummaryCollectFromDriver: response.data.getSummaryCollectFromDriver,
      getSummaryPayToDriver: response.data.getSummaryPayToDriver
    }
  })

  export const getPendingExpenseData = createAsyncThunk('appDriverBookingExpense/getPendingExpenseData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DriverBookingExpense/GetPendingBookExpenses', params, {mode:'cors'})
    return {
      params,
      allData: response.data.allData
    }
  })

  export const CreateInvoice = createAsyncThunk('appDrvrPayment/Create', async (Driver) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/CreateInvoice', Driver, {mode:'cors'})
    return response
  })

  export const getTotalBillPayment = createAsyncThunk('appDrvrPayment/getTotalBillPayment', async (Driver) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetDriversBillTotalPayment', Driver, {mode:'cors'})
    return response
  })

  export const getTotalInvoicePayment = createAsyncThunk('appDrvrPayment/getTotalInvoicePayment', async (Driver) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetDriversInvoiceTotalPayment', Driver, {mode:'cors'})
    return response
  })
  export const getGenerateDocumentDrvrPayment = createAsyncThunk('appDriver/getGenerateDocumentDrvrPayment', async (DocumentExcel) => {
      
    const response = await axios.post('https://api.zasway.com:8443/BookingInvoice/GetGenerateDocumentDriverPayment', DocumentExcel, {mode:'cors'})
      
    return response.data
  })
  export const AddDrvrPaymentAdjustments = createAsyncThunk('appDriver/getGenerateDocumentDrvrPayment', async (DocumentExcel) => {
     
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/AddDriverPaymentAdjustments', DocumentExcel, {mode:'cors'})
     
    return response.data
  })
  export const DeleteAdjustments = createAsyncThunk('appDriver/DeleteAdjustments', async (DocumentExcel) => {
     
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/DeleteDriverPaymentAdjustment', DocumentExcel, {mode:'cors'})
     
    return response.data
  })
  
  export const gettaxlist = createAsyncThunk('appCreditNote/getTaxList', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetTaxList')
    return response.data
})
export const getadjustments = createAsyncThunk('appCreditNote/getTaxList', async (params) => {
   
  const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetDriverPaymentAdjustments', params)
  return response.data
})
  export const getDriversInvoice = createAsyncThunk('appDrvrPayment/GetDriversInvoice', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetDriversInvoice', params)
    return response.data
  })

  export const CreateBillPayments = createAsyncThunk('appDrvrPayment/CreateBillPayments', async (Driver) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/CreateBillPayments', Driver, {mode:'cors'})
    return response
  })

  export const getBillPayments = createAsyncThunk('appDrvrPayment/GetBillPayments', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetBillPayments', params)
    return response.data
  })

  export const getPaymentMethodList = createAsyncThunk('appDrvrPayment/getPaymentMethodList', async (params) => {
    const companyID = JSON.parse(localStorage.getItem('companyID')) || 0
    const response = await axios.post('https://api.zasway.com:8443/Common/GetPaymentMethodList', params || { companyID })
    return response.data
  })

  export const deleteGeneratedPayment = createAsyncThunk('appDrvrPayment/DeleteGeneratedPayment', async (id) => {
      
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/DeleteGeneratedPayment', id, {mode:'cors'})
      return response
  })

  export const deletePayToDriver = createAsyncThunk('appDrvrPayment/DeletePayToDriver', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/DeletePayToDriver', id, {mode:'cors'})
    return response
  })

  export const deleteCollectFromDriver = createAsyncThunk('appDrvrPayment/DeleteCollectFromDriver', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/DeleteCollectFromDriver', id, {mode:'cors'})
    return response
  })

  export const deleteBillPayments = createAsyncThunk('appDrvrPayment/DeleteBillPayments', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/DeleteBillPayments', id, {mode:'cors'})
    return response
  })

  export const deleteInvoicePayments = createAsyncThunk('appDrvrPayment/DeleteInvoicePayments', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/DeleteInvoicePayments', id, {mode:'cors'})
    return response
  })

  export const approvePayments = createAsyncThunk('appDrvrPayment/ApprovePayments', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/ApprovePayments', id, {mode:'cors'})
    return response
  })
  export const settlePayments = createAsyncThunk('appDrvrPayment/settlePayments', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/SettlePayments', id, {mode:'cors'})
    return response
  })

  export const getDriverDeductionsList = createAsyncThunk('appDrvrPayment/getDriverDeductionsList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/GetTableSummaryDriverDeductions', params)
    return response.data
  })

  export const updateCommissionsGeneratedPaymentsViews = createAsyncThunk('appDrvrPayment/updateCommissionsGeneratedPaymentsViews', async (updateCommissions) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/updateCommissionsGeneratedPaymentsViews', updateCommissions, {mode:'cors'})
    return response.data
  })

  export const updateCommissionsPaymentsCollectFromDriver = createAsyncThunk('appDrvrPayment/UpdateCommissionsGetCollectFromDriverDetail', async (updateCommissions) => {
    const response = await axios.post('https://api.zasway.com:8443/DrvrPayment/UpdateCommissionsGetCollectFromDriverDetail', updateCommissions, {mode:'cors'})
    return response.data
  })
  
export const appDrvrPaymentSlice = createSlice({
  name: 'appDrvrPayment',
  initialState: {
    eligibleDriverData: [],
    eligibleDriverTotal: 0,
    eligibleDriverParams: {},
    eligibleDriverAllData: [],
    generatedPaymentData: [],
    generatedPaymentTotal: 1,
    generatedPaymentParams: {},
    generatedPaymentAllData: [],
    attentionPaymentData: [],
    attentionPaymentTotal: 1,
    attentionPaymentParams: {},
    attentionPaymentAllData: [],
    getDrvrPaymentsMaster: [],
    getDriverPaymentMaster: [],
    getCollectFromDriverDetail: [],
    getPayToDriverDetail: [],
    getSummaryCollectFromDriver: [],
    getSummaryPayToDriver:[],
    editID:1,
    declineExpenseData: [],
    declineExpenseTotal: 1,
    declineExpenseParams: {},
    declineExpenseAllData: [],
    pendingExpenseData: [],
    pendingExpenseTotal: 1,
    pendingExpenseParams: {},
    pendingExpenseAllData: [],
    dates: [],
    checked: false
  },
  reducers: {},
    extraReducers: builder => {
    builder

      .addCase(getDeclineExpenseData.fulfilled, (state, action) => {
        state.declineExpenseData = action.payload.data
        state.declineExpenseAllData = action.payload.allData
        state.declineExpenseTotal = action.payload.totalPages
        state.declineExpenseParams = action.payload.params
      })

      .addCase(getEligibleDriversData.fulfilled, (state, action) => {
          
        state.eligibleDriverData = action.payload.data
        state.eligibleDriverAllData = action.payload.allData
        state.eligibleDriverTotal = action.payload.totalPages
        state.eligibleDriverParams = action.payload.params
      })

      .addCase(getPendingExpenseData.fulfilled, (state, action) => {
        state.pendingExpenseAllData = action.payload.allData
        state.pendingExpenseParams = action.payload.params
      })

      .addCase(getGeneratedPaymentsData.fulfilled, (state, action) => {
        state.generatedPaymentData = action.payload.data
        state.generatedPaymentAllData = action.payload.allData
        state.generatedPaymentTotal = action.payload.totalPages
        state.generatedPaymentParams = action.payload.params
      })

      .addCase(getAttentionPaymentsData.fulfilled, (state, action) => {
         state.attentionPaymentData = action.payload.data
         state.attentionPaymentAllData = action.payload.allData
         state.attentionPaymentTotal = action.payload.totalPages
         state.attentionPaymentParams = action.payload.params
       })

      .addCase(getGeneratedPaymentsViewsData.fulfilled, (state, action) => {
        
        state.getDrvrPaymentsMaster = action.payload.getDrvrPaymentsMaster
        state.getDriverPaymentMaster = action.payload.getDriverPaymentMaster
        state.getCollectFromDriverDetail = action.payload.getCollectFromDriverDetail
        state.getPayToDriverDetail = action.payload.getPayToDriverDetail
        state.getSummaryCollectFromDriver = action.payload.getSummaryCollectFromDriver
        state.getSummaryPayToDriver = action.payload.getSummaryPayToDriver
        
      })

      .addCase(setEditID.fulfilled, (state, action) => {
        state.editID = action.payload.id
      })

      .addCase(setPickerValues.fulfilled, (state, action) => {
        state.dates = action.payload.data.Dates
      })
      .addCase(setEligibleCheck.fulfilled, (state, action) => {
         
        state.checked = action.payload.data.CHECKED
      })
      
    }
  })
  
export default appDrvrPaymentSlice.reducer